module.exports = __webpack_public_path__ + "img/arrow.986de014.svg";